export enum ApplicationOrderTemplate {
    PurchaseOrder = "PurchaseOrder",
    WeightBasedOrder = "WeightBasedOrder",
    VatOrder = "VatOrder"
}